import React, { useMemo } from "react";

import { FlightCircuit as FlightCircuitComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { isComponentPartOfSharedRow } from "@/pages/session-detail/utils/utils";
import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

import { mockExpectedFlightData } from "./flightCircuitMockData";

interface FlightCircuitProps {
    isInsideModal?: boolean;
    subDimensionData?: any;
}

const FlightCircuit: React.FC<FlightCircuitProps> = ({ subDimensionData, isInsideModal }) => {
    const { flightCircuitData, isFetchingFlightCircuit, isErrorFlightCircuit, gridLayoutData } =
        useSessionDetailsContext();

    //Store mock data unless there is real expectedFlightPath data
    const expectedData =
        flightCircuitData?.pathData?.expectedFlightData?.length > 0
            ? flightCircuitData.pathData.expectedFlightData
            : mockExpectedFlightData;

    //Create a new data object with the updated expectedPath data
    const updatedFlightCircuitData = {
        ...flightCircuitData,
        pathData: {
            ...flightCircuitData?.pathData,
            expectedFlightData: expectedData,
        },
    };

    const isPartOfSharedRow = useMemo(() => {
        return isComponentPartOfSharedRow(gridLayoutData, "FlightCircuit");
    }, [gridLayoutData]);

    const hasFlightData =
        updatedFlightCircuitData?.pathData?.expectedFlightData?.length > 0 &&
        updatedFlightCircuitData?.pathData?.flightData?.length > 0;

    const isEmptyState =
        (!isErrorFlightCircuit &&
            !subDimensionData &&
            (updatedFlightCircuitData === null ||
                !hasFlightData ||
                Object.keys(updatedFlightCircuitData).length === 0)) ||
        !hasFlightData;

    if (isFetchingFlightCircuit) {
        return <ContentLoader height={isPartOfSharedRow ? "21.1875rem" : "22.9375rem"} />;
    }

    if (isEmptyState) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:flight-circuit:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight={isPartOfSharedRow ? "18.1875rem" : "19.9375rem"}
                />
            </ComponentWrapper>
        );
    }

    if (isErrorFlightCircuit && !isFetchingFlightCircuit) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight={isPartOfSharedRow ? "18.1875rem" : "19.9375rem"}
                />
            </ComponentWrapper>
        );
    }

    return (
        <FlightCircuitComponent
            data={isInsideModal ? subDimensionData : updatedFlightCircuitData}
        />
    );
};

export default FlightCircuit;
